module.exports = __webpack_public_path__ + "static/media/Sawk_gaussian2.5566635f.png";